import {
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";

// The selectable list of IDs a query found, down the left of each tab.
// items: [{ id, subtitle }]
function IdList({ title, items, selected, onSelect, emptyText, loaded }) {
  return (
    <div>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2" color="text.secondary">
        {!loaded ? "Run a query to list IDs." : items.length ? `${items.length} found` : emptyText}
      </Typography>
      <List dense sx={{ maxHeight: 300, overflow: "auto" }}>
        {items.map((item) => (
          <ListItemButton
            key={item.id}
            selected={item.id === selected}
            onClick={() => onSelect(item.id)}
          >
            <ListItemText
              primary={item.id}
              secondary={item.subtitle}
              primaryTypographyProps={{ fontFamily: "monospace", fontSize: 13 }}
              secondaryTypographyProps={{ fontSize: 11 }}
            />
          </ListItemButton>
        ))}
      </List>
    </div>
  );
}

export default IdList;
